import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import AppPrompt from "@/components/Shared/AppPrompt";
Vue.config.productionTip = false;

import './scss/main.scss'

import {newReq, newReqDownloadFile, newReqUpload} from './core/request';
Vue.prototype.$newReq = newReq;
Vue.prototype.$newReqDownloadFile = newReqDownloadFile;
Vue.prototype.$newReqUpload = newReqUpload;

import snack from './core/snack'
Vue.prototype.$snack = snack;

function prompt(context, title="title", prompt="prompt", buttons=[]) {
  return new Promise((resolve, reject) => {
    function destroyPrompt(context, instance, value = null) {
      instance.$off('dismissed', () => destroyPrompt('dismissed'));
      instance.$off('action', (e) => destroyPrompt(e));
      context.$el.removeChild(instance.$el)
      instance.$destroy()
      resolve(value)
    }

    try {
      // Create The Component
      let ComponentClass = Vue.extend(AppPrompt)
      let instance = new ComponentClass({
        propsData: {
          title,
          prompt,
          buttons,
        }
      })
      instance.$vuetify = context.$vuetify

      // Add Event Listeners
      instance.$once('dismissed', () => destroyPrompt(context, instance, 'dismissed'));
      instance.$once('action', (e) => destroyPrompt(context, instance, e));

      // Mount Dlg
      instance.$mount() // pass nothing
      context.$el.appendChild(instance.$el)
    } catch (e) {
      reject(e)
    }
  })
}

Vue.prototype.$showPrompt = prompt


import store from './core/store';

new Vue({
  vuetify,
  render: h => h(App),
  store
}).$mount('#app');
